<div class="loading" [hidden]="!loading">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>

<router-outlet></router-outlet>
